import Checkbox from "../../Checkbox/Checkbox";
import FieldGroup from "../../FieldGroup/FieldGroup";

const defineAccesory = (item) => ({
    id: item.id,
    label: item.label,
    name: item.name,
    quantity: item.quantity || 1,
    price: item.price,
});

const hasQuantity = (item) => item.quantity !== undefined;

const isActive = (accessories, id) => accessories.some((accesory) => accesory.id === id);

const removeAccesory = (accessories, id) => accessories.filter((accesory) => accesory.id !== id);

const sort = (accessories) => accessories.sort((a, b) => a.id - b.id);

const Accessories = ({ data, onCheck, activeAccessories }) => {
    const handleCheck = (accesory) => {
        const {
            id,
            target: {
                target: { checked },
            },
        } = accesory;
        const active = isActive(activeAccessories, id);
        const updatedAccessories = removeAccesory(activeAccessories, id);

        if (checked === false && active) return onCheck(sort(updatedAccessories));

        if (hasQuantity(accesory) && active) return onCheck(sort([...updatedAccessories, defineAccesory(accesory)]));

        return onCheck(sort([...activeAccessories, defineAccesory(accesory)]));
    };

    return (
        <FieldGroup title="Accesories" id={1}>
            {data.map((acc, index) => (
                <Checkbox
                    id={index}
                    key={index}
                    type="checkbox"
                    label={acc.label}
                    price={acc.price}
                    highlight={acc.highlight}
                    tooltip={acc.tooltip}
                    name={acc.name}
                    isChecked={activeAccessories.some((item) => item.id === index)}
                    isDisabled={false}
                    onChange={(item) => handleCheck(item)}
                    maxQuantity={acc.maxQuantity}
                    image={acc.image}
                    sideNotes={acc.sideNotes}
                    showPrice
                />
            ))}
        </FieldGroup>
    );
};

export default Accessories;
